import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import { numberWithLessDecimals } from 'hb-react/shared/utils/formatNumber';

interface Currency {
  symbol: string;
}

interface Campaign {
  amounts: string[];
  currency: Currency;
}

interface AmountsProps {
  campaign: Campaign;
  selectedAmount?: string;
  onSelect: (amount: string) => void;
}

interface AmountButtonProps {
  $isSelected?: boolean;
}

const Amounts = ({ campaign, selectedAmount, onSelect }: AmountsProps) => {
  if (campaign.amounts.length === 0) {
    return null;
  }

  return (
    <Box display="inline-block">
      {campaign.amounts.map((amount) => (
        <AmountButton
          data-testid={amount === selectedAmount ? 'amount-selected' : null}
          key={amount}
          onClick={() => onSelect(amount)}
          $isSelected={amount === selectedAmount}
        >
          {`${campaign.currency.symbol} ${numberWithLessDecimals(amount)}`}
        </AmountButton>
      ))}
    </Box>
  );
};

export default Amounts;

const AmountButton = styled.a<AmountButtonProps>`
  display: inline-block;
  border-radius: 6px;
  background-color: #f4f4f4;
  color: ${({ theme }) => theme.colors.asphalt};
  font-weight: 600;
  font-size: 16px;
  padding: 20px;
  margin-right: 26px;
  margin-bottom: 0.8em;

  ${({ $isSelected, theme }) =>
    $isSelected &&
    `
      background-color: ${theme.colors.primary};
      color: ${theme.colors.white};
      outline: none;
      box-shadow: 2px 4px 5px rgba(0, 0, 0, 0.15);
    `}
`;
